import { Component, OnInit, Inject, ChangeDetectorRef } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { AgentEmployeeService } from '../../services/agent-employee/agent-employee.service';
import { UploadService } from '../../services/upload/upload.service';
import { documentInformation } from '../../model/document.model';
import * as momenttimezone from 'moment-timezone';
import { ChangeLogService } from '../../services/change_log/change-log.service';
import { GoogleAnalyticsService } from '../../services/google_analytics/google-analytics.service';
import { GetDocStatusByRole } from '../../../shared/globalService';
@Component({
  selector: 'app-agent-employee-dialog',
  templateUrl: './agent-employee-dialog.component.html',
  styleUrls: ['./agent-employee-dialog.component.css']
})
export class AgentEmployeeDocsDialogComponent implements OnInit {

  backgroundCheck: boolean = false;
  carsCertification: boolean = false;
  additionalDocForm: boolean = false;
  ofac: boolean = false;
  carsCertificatioFoEmployees: boolean = false;
  matSpinner: boolean = false;
  public submitFormData: any;
  chooseFile: boolean = false;
  updateFile: boolean = false;
  isFileChanged: boolean = false;
  onChangeFileName: string;
  onChangeFile: boolean = false;
  agentId: any;
  vendorName;
  minDate = new Date();
  empId: any;
  loginId;
  errMsg;
  errFlag: boolean = false;
  uploadErrMsg;
  uploadErrFlag: boolean = false;
  logFormData: any;
  issueDt: any;
  uploadFlag: boolean = true;
  signedUrl;
  newFilePath;
  newFilePath1;
  firstName;
  lastName;
  data: any = {
    completionDate: '',
    expirationDate: '',
    issueDate: '',
    externalURL: '',
    fileName: '',
  }
  documentInfo: documentInformation = new documentInformation();
  previousValues: any = [];
  constructor(
    private getDocStatusByRole: GetDocStatusByRole,
    private googleAnalyticsService: GoogleAnalyticsService,
    private changelogservice: ChangeLogService, private agentemployeeservice: AgentEmployeeService,
    public ref: ChangeDetectorRef, public dialogRef: MatDialogRef<AgentEmployeeDocsDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public agentData: any, private uploadService: UploadService) { }

  setFileData(docInfo) {
    this.googleAnalyticsService.emitEvent(this.firstName + ' ' + this.lastName, "Uploaded a" + ' ' + this.agentData.data.DocumentTypeName + ' ' + 'Document', this.vendorName, 10);
    setTimeout(() => {
      this.documentInfo = docInfo;
      this.data.fileName = this.documentInfo.fileName;
      this.ref.markForCheck();
      this.ref.detectChanges()
    }, 100);
    // will be used to upload the file into amazon
    this.isFileChanged = true;
  }

  ngOnInit() {
    this.vendorName = localStorage.getItem('AgentName');
    this.agentId = localStorage.getItem("AgentId");
    this.empId = localStorage.getItem("EmployeeId");
    this.loginId = localStorage.getItem('loginID');
    this.firstName = localStorage.getItem("username");
    this.lastName = localStorage.getItem('Lastname');
    if (this.agentData.data.DocumentTypeName == "Background Check") {
      this.backgroundCheck = true;
    }
    else if (this.agentData.data.DocumentTypeName == "CARS Certification") {
      this.carsCertification = true;
    }
    else if (this.agentData.data.DocumentTypeName == "OFAC") {
      this.ofac = true;
    } else if (this.agentData.data.DocumentTypeName == "Additional Documents") {
      this.additionalDocForm = true;
    }
    if (this.agentData.type === 'update') {
      this.chooseFile = false;
      this.updateFile = true;
      this.onChangeFile = true;
      let dt = new Date(this.agentData.data.CompletionDate);
      if (dt !== undefined)
        this.data.completionDate = dt;
      let pt = this.agentData.data.ExpirationDate != null? new Date(this.agentData.data.ExpirationDate) : '';
      if (pt !== undefined)
        this.data.expirationDate = pt;
      let dt1 = new Date(this.agentData.data.IssueDate);
      if (dt1 !== undefined)
        this.data.issueDate = dt1;
      this.data.externalURL = this.agentData.data.DocumentLink;
      this.data.fileName = this.agentData.data.FileName;
    }

    if (this.agentData.type === 'create') {
      this.chooseFile = true;
      this.updateFile = false;
    }
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  saveDocument() {
    this.matSpinner = true;
    let today = new Date();
    this.uploadFlag = false;
    const estTimeZone = 'America/New_York';
    let uploadTimeZone = momenttimezone(today).tz(estTimeZone).format();
    uploadTimeZone = uploadTimeZone.replace(/[^a-zA-Z0-9]/g, '');

    if (this.isFileChanged === false && this.agentData.type === 'update') {
      this.submitForm();
    }
    else {
      var filePath = "Agent/" + this.agentId + "/employee/" + this.empId + "/" + this.agentData.data.DocumentTypeCode + "/";
      this.data.fileName = this.documentInfo.fileName;
      let fileNameWithoutExt = this.documentInfo.fileName.substring(0, this.documentInfo.fileName.lastIndexOf('.'));
      let fileNameExt = this.documentInfo.fileName.substring(this.documentInfo.fileName.lastIndexOf('.') + 1, this.documentInfo.fileName.length);
      this.documentInfo.fileInput.append('url', filePath + fileNameWithoutExt + '_' + uploadTimeZone + '.' + fileNameExt);
      this.newFilePath1 = filePath + fileNameWithoutExt + '_' + uploadTimeZone + '.' + fileNameExt;
      let body = {
        "newFilePath": this.newFilePath1,
        "vendor_id": this.agentId
      }
      this.uploadService.getSignedURL(body).subscribe((res) => {
        this.signedUrl = res.Info;
        this.uploadService.uploadDocumentWithSignedUrl(this.documentInfo.file, this.signedUrl).subscribe((obj) => {
          this.data.externalURL = this.newFilePath1;
          this.submitForm();
        });
      }, (err) => {
        this.uploadErrMsg = 'Upload service' + err;
        this.uploadErrFlag = true;
        this.matSpinner = false;
      });
    }
  }

  onFileChange(event) {
    this.isFileChanged = true;
    this.onChangeFile = false;
    const reader = new FileReader();
    const formInput: FormData = new FormData();
    if (event.target.files && event.target.files.length > 0) {
      const file = event.target.files[0];
      this.onChangeFileName = file.name;
      var extName = file.name.split('.').pop();
      var ext = extName.toLowerCase()
      if (ext == "docx" || ext == "pdf" || ext == "doc" || ext == "png" || ext == "jpg" || ext == "xls" || ext == "xlsx") {
        formInput.append('file', file, file.name);
        this.documentInfo.fileInput = formInput;
        this.documentInfo.fileName = file.name;
      } else {
      }
    }
  }

  submitForm() {
    var testTimeZone= "";
    if(this.data.expirationDate){
    const setTime = new Date(this.data.expirationDate);
    setTime.setHours(19);
    setTime.setMinutes(59);
    setTime.setSeconds(59);
    const estTimeZone = "America/New_York";
    const format = "YYYY-MM-DDTHH:mm:ss.SSSZ";
    testTimeZone = momenttimezone(setTime).tz(estTimeZone).format(format);
    /*** The following logic for Daylight Savings ***/
    if (testTimeZone.includes('-05:00')) {
      testTimeZone = testTimeZone.replace('19:59:59', '18:59:59');
    }
  }
    this.submitFormData = {
      "vendor_id": this.agentId,
      "employee_id": this.empId,
      "docId": this.agentData.data._id,
      "document_type_code": this.agentData.data.DocumentTypeCode,
      "document_type_name": this.agentData.data.DocumentTypeName,
      "document_link": this.data.externalURL,
      "file_name": this.data.fileName,
      'expiry_dtm': testTimeZone,
      'completion_dtm': this.data.completionDate,
      'issue_dtm': this.data.issueDate,
      "DocumentStatus": this.getDocStatusByRole.docStatusByRole()
    }
    this.logFormData = {
      "document_type": this.agentData.data.DocumentTypeName,
      "document_category": this.agentData.data.DocumentCategory,
      "transaction_type": "Add",
      "vendor_id": this.agentId
    }
    if (this.agentData.type === 'create') {
      this.submitFormData.created_by = this.loginId;
      this.submitFormData.updated_by = this.loginId;
      this.logFormData.modified_by = this.loginId;
      this.logFormData.employee_name = localStorage.getItem('EmployeeName');
      this.agentemployeeservice.submitDocumentVal(this.submitFormData).subscribe(res => {
        this.googleAnalyticsService.emitEvent(this.firstName + ' ' + this.lastName, "Created a" + ' ' + this.agentData.data.DocumentTypeName + ' ' + 'Document', this.vendorName, 10);
        if (res.Status == 200) {
          this.agentemployeeservice.load.next('success');
          this.changelogservice.sendLogs(this.logFormData).subscribe(res => { }, err => {
            this.errMsg = err;
            this.errFlag = true;
            this.matSpinner = false;
          });
          this.onNoClick();
        }
      }, err => {
        this.errMsg = err;
        this.errFlag = true;
        this.matSpinner = false;
      });
    }
    else if (this.agentData.type === 'update') {
      this.submitFormData.updated_by = this.loginId;
      this.submitFormData.fileUpdated = this.isFileChanged;
      this.logFormData.modified_by = this.loginId;
      this.agentemployeeservice.updateEmpDocuments(this.submitFormData).subscribe(res => {
        this.googleAnalyticsService.emitEvent(this.firstName + ' ' + this.lastName, "Updated a" + ' ' + this.agentData.data.DocumentTypeName + ' ' + 'Document', this.vendorName, 10);
        if (res.Status == 200) {
          this.agentemployeeservice.load.next('success');
          if (this.logFormData.transaction_type == "Add") {
            this.logFormData.transaction_type = "Edit";
            this.previousValues = localStorage.getItem('old');
            this.logFormData.previous_fields = JSON.parse(this.previousValues);
            this.logFormData.previous_fields.EmployeeName = localStorage.getItem('EmployeeName');
            this.logFormData.collection_name = "vendor_employee_documents";
            this.changelogservice.sendLogs(this.logFormData).subscribe(res => { }, err => {
              this.errMsg = err;
              this.errFlag = true;
              this.matSpinner = false;
            });
          }
          this.onNoClick();
        }
      }, err => {
        this.errMsg = err;
        this.errFlag = true;
        this.matSpinner = false;
      });
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/components/agent-employee-docs-dialog/agent-employee-dialog.component.ts